import React from "react";
import ActionButton from "../partials/ActionButton";
import StagesManager from "../StagesManager";
import FormViewer from "../FormViewer";
import ViewSwitcher from "../ViewSwitcher";
import ViewsMenu from "../header/ViewsMenu";
import { chooseFontColor, imageAddress, textVariableReplacer, translate } from "../../utils/useful";
import ButtonAnimated from "../buttons/ButtonAnimated";
import HttpServices from "../../utils/Http.services";
import RecordViewerModal from "../../modals/RecordViewerModal";
import { saveAs } from 'file-saver';
import importedIcons from "../inputs/icons";

class ViewSwitcherWidget extends React.Component {
    state = {

        limit: 12,
        skip: 0,
        currentView: "table",
        // pje: [
        //     { name: '1Attend a business meeting ...', dec: 'Attend a business meeting Attend a business meeting Attend a business meeting Attend a business meeting', time: '6:30 am', img: "/images/p1.png", img2: "/images/p3.png" },
        //     { name: '1Reading Book', dec: 'Attend a business meeting Attend a business meeting Attend a business meeting Attend a business meeting', time: '10:30 pm', img: "/images/p2.png", img2: "/images/p1.png" },
        //     { name: '1Reading Book', dec: 'Attend a business meeting Attend a business meeting Attend a business meeting Attend a business meeting', time: '5:00 pm', img: "/images/p4.png", img2: "/images/p5.png" },
        //     { name: 'Attend a business meeting ...', dec: 'Attend a business meeting Attend a business meeting Attend a business meeting Attend a business meeting', time: '1:30 am', img: "/images/p7.png", img2: "/images/p6.png" },
        //     { name: 'Reading Book', dec: 'Attend a business meeting Attend a business meeting Attend a business meeting Attend a business meeting', time: '10:30 pm', img: "/images/p1.png", img2: "" },
        //     { name: 'Attend a business meeting ...', dec: 'Attend a business meeting Attend a business meeting Attend a business meeting Attend a business meeting', time: '10:30 am', img: "/images/p1.png", img2: "/images/p8.png" },

        // ],
        category: [
            { bg: "bg-red-300", name: "All", title: "Attend a business meeting ...", des: "meeting Attend a business meeting Attend a business meeting Attend a business meeting", title1: "Do somthing", des1: "meeting Attend a business meeting Attend a business meeting Attend a business meeting", },
            { bg: "bg-red-300", name: "Pending", title: "Attend a business meeting ...", des: "meeting Attend a business meeting Attend a business meeting Attend a business meeting", title1: "Exercise", des1: "meeting Attend a business meeting Attend a business meeting Attend a business meeting", },
            { bg: "#99FFFF", name: "Open", title: "Reading Book", des: "meeting Attend a business meeting", title1: "Painting", des1: "meeting Attend a business meeting Attend a business meeting Attend a business meeting", },
            { bg: "#DF73FF", name: "Closed", title: "Attend a business meeting ...", des: "choose the best option and create a pleasant shopping experience. .", title1: "Do somthing", des1: "meeting Attend a business meeting Attend a business meeting Attend a business meeting", },

        ],
        actions: {
            // done: { key: "done", label: '{{lang}}Mark as done', color: '#000', bgColor: 'linear-gradient(to right, rgba(70, 133, 204, 0.9), rgba(70, 70, 204, 0.9))', function: this.openEditModal },
            edit: { key: "edit", label: '{{lang}}View / Edit', color: '#000', bgColor: 'linear-gradient(to right, rgba(70, 133, 204, 0.9), rgba(70, 70, 204, 0.9))', function: "openEditModal", icon: importedIcons.edit },
            doneTask: { key: "doneTask", label: '{{lang}}DoneTask', color: '#000', bgColor: 'linear-gradient(to right, rgba(70, 133, 204, 0.9), rgba(70, 70, 204, 0.9))', function: "doneTask", icon: importedIcons.changeStage },

            changeStage: { key: "changeStage", label: '{{lang}}Change Stage', sub: true, color: '#000', bgColor: 'linear-gradient(to right, rgba(70, 133, 204, 0.9), rgba(70, 70, 204, 0.9))', function: "changeRecordStageModal", icon: importedIcons.changeStage },
            nextStage: { key: "nextStage", label: '{{lang}}Next Stage', color: '#000', bgColor: 'linear-gradient(to right, rgba(70, 133, 204, 0.9), rgba(70, 70, 204, 0.9))', function: "nextRecordStage", icon: importedIcons.changeStage },

            subTask: { key: "subTask", label: '{{lang}}Add Sub Task', color: '#000', bgColor: 'linear-gradient(to right, rgba(70, 133, 204, 0.9), rgba(70, 70, 204, 0.9))', function: "addSubTask", icon: importedIcons.tasking },
            sendTo: { key: "sendTo", label: '{{lang}}Send To', sub: true, color: '#000', bgColor: 'linear-gradient(to right, rgba(70, 133, 204, 0.9), rgba(70, 70, 204, 0.9))', function: "sendTo", icon: importedIcons.send },

            request: { key: "request", label: '{{lang}}Request', color: '#000', bgColor: 'linear-gradient(to right, rgba(70, 133, 204, 0.9), rgba(70, 70, 204, 0.9))', function: "openEditModal", icon: importedIcons.request },
            openWindow: { key: "openWindow", label: '{{lang}}Open Window', color: '#000', bgColor: 'linear-gradient(to right, rgba(70, 133, 204, 0.9), rgba(70, 70, 204, 0.9))', function: "openWindow", icon: importedIcons.request },
            extra: { key: "extra", label: '{{lang}}Extra', color: '#000', bgColor: 'linear-gradient(to right, rgba(70, 133, 204, 0.9), rgba(70, 70, 204, 0.9))', function: "openEditModal", icon: importedIcons.more },

            remove: { key: "remove", label: '{{lang}}remove', color: '#ee5050', borderTop: '1px solid #eee', icon: importedIcons.trash, function: "openRemoveModal" },

            duplicate: { key: "duplicate", label: '{{lang}}Duplicate', color: '#000', icon: importedIcons.copy, bgColor: 'linear-gradient(to right, rgba(70, 133, 204, 0.9), rgba(70, 70, 204, 0.9))', function: "duplicateElement" },
            share: { key: "share", label: '{{lang}}Share', color: '#000', bgColor: 'linear-gradient(to right, rgba(70, 133, 204, 0.9), rgba(70, 70, 204, 0.9))', function: "openEditModal", icon: importedIcons.share },
            activityLogs: { key: "activityLogs", label: '{{lang}}Activity Logs', icon: importedIcons.activityLog, color: '#000', bgColor: 'linear-gradient(to right, rgba(70, 133, 204, 0.9), rgba(70, 70, 204, 0.9))', function: "getActivityLogs" },
            setAsHomePage: { key: "setAsHomePage", label: 'Set As Home Page', icon: importedIcons.activityLog, color: '#000', bgColor: 'linear-gradient(to right, rgba(70, 133, 204, 0.9), rgba(70, 70, 204, 0.9))', function: "setAsHomePage" },
        },
        headers: [
            // { key: 'title', type: 'TextInput', col: '12', information: { label: '{{lang}}Title', inplaceEditable: true, placeholder: '{{lang}}desk.insert', required: false, disabled: true }, showMain: true },
            // { key: 'dueDate', type: 'DateInput', col: '6', information: { label: '{{lang}}Assignee', inplaceEditable: true, placeholder: '{{lang}}desk.Date', required: true }, showMain: true },
            // { key: 'priority', type: 'StatusSelectInput', inPlaceEdit: true, information: { label: '{{lang}}Time', inplaceEditable: true, placeholder: '{{lang}}desk.priority', items: [{ label: '{{lang}}desk.High', key: 'high', color: '#CA5C72', bgColor: '#FEE9EE' }, { label: '{{lang}}desk.Medium', key: 'medium', color: '#CAA55C', bgColor: '#FEF2E9' }, { label: '{{lang}}desk.Low', key: 'low', color: '#00c875', bgColor: '#00c87520' }], required: false } },
            // { key: 'assignees', type: 'GlobalUserMultiInput', information: { label: '{{lang}}desk.Assignees', inplaceEditable: true, address: 'searchUser', filter: {}, fields: { title: 'fullname', description: 'username', value: '_id', image: 'image' }, type: 'api', isSearchable: true, placeholder: '{{lang}}desk.select', required: false, } },
            // { key: 'source', type: 'SelectInput', fullCol: true, information: { label: '{{lang}}desk.Source', inplaceEditable: true, required: true, type: 'local', default: '0', items: [{ title: "{{lang}}desk.Cash", value: 'C', color: '#789' }, { title: "{{lang}}desk.Credit Card", value: 'CC', color: '#789' },] }, showMain: true, inExport: true },
            // { key: 'tags', type: 'MultiSelectInput', fullCol: true, information: { label: '{{lang}}desk.Tags', inplaceEditable: true, required: true, type: 'local', default: '0', items: [{ title: "{{lang}}desk.Cash", value: 'C', color: '#789' }, { title: "{{lang}}desk.Credit Card", value: 'CC', color: '#789' },] }, showMain: true, inExport: true },

        ],


    }


    componentDidMount() {

        // console.log("componentDidMount")
        this.setState({ currentIndex: 0, currentItem: this.state.category[0] })
        this.init()
    }



    init() {

        if (!this.props.isDragging) {
            let data = { ...this.props.data }
            this.setState({ information: data })
            let body = { 
                collection: data.collection,
                filter: data.filter

             }

            if (this.props.variables?.appletHub) {
                body.appletHub = this.props.variables?.appletHub
            }

            let currentData = {}

            this.setState({ isLoading: true })

            // console.log("body",body)

            HttpServices.request("getWidgetRecords", body, (fetchResult, fetchError, status) => {
                // SocketServices.addTopic(this.state.topicId, this.props.data.thing, 'things', null, this.updateData)

                if(fetchError){
                    return
                }
                // console.log(fetchResult,fetchError)
                this.setState({ isLoading: false })


                currentData.data = fetchResult.info
                currentData.frames = fetchResult.frames


                // TO DO: FRAME INFO AND FRAMES FIELDS
                this.setState({ data: fetchResult.info, frames: fetchResult.frames, frame: fetchResult.frames[0], showTable: true }, () => {

                    this.props.keepCurrentData(this.props.section, currentData)
                })

                return
                if (fetchError) { return }

                let frame = fetchResult?.info

                frame.key = frame._id
                frame.section = 'collections'
                frame.pageType = 'collection'
                frame.fetchUrl = 'getRecords'
                frame.addUrl = 'postRecord'
                frame.editUrl = 'postRecord'
                frame.removeUrl = 'removeRecord'
                frame.postBody = { hub: frame?.applet?.hub, applet: frame?.applet?._id }
                frame.filter = { hub: frame?.applet?.hub, applet: frame?.applet?._id }
                frame.fields.forEach(field => {
                    if (!field.key.includes("values.")) {

                        field.key = "values." + field.key
                    }
                });

                currentData.frame = frame
                this.setState({ frame: frame }, () => {


                    // let body = frame.filter ? { ...frame.filter } : {}

                    // body.limit = this.state.limit
                    // body.skip = this.state.skip



                    // for (const [key, value] of Object.entries(body)) {
                    //     if (/\{\{(.*?)\}\}/.test(value)) {
                    //         if (this.props.variables) {
                    //             body[key] = this.props.variables[value.replace(/{/g, '').replace(/}/g, '')]
                    //         }
                    //     }
                    // }
                    // body.frame = frame?._id

                    this.setState({ isLoadingData: true })

                    let recordsFetchResult = {}
                    // HttpServices.request(frame.fetchUrl, body, (recordsFetchResult, fetchError) => {
                    //     this.setState({ isLoadingData: false })
                    //     if (fetchError) {
                    //         this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.loadDataFailed', description: fetchError.message })
                    //         return
                    //     }
                    //     this.setState({ showTable: false }, () => {

                    currentData.data = recordsFetchResult.info

                    this.setState({ data: recordsFetchResult.info, showTable: true }, () => {

                        this.props.keepCurrentData(this.props.section, currentData)
                    })
                    // })
                    // })


                })

            })
        } else if (this.props.currentData) {
            let currentData = this.props.currentData
            this.setState({ data: currentData.data, frame: currentData.frame, showTable: true })
        }

    }


    // init() {

    //     if (!this.props.isDragging) {
    //         let data = { ...this.props.data }
    //         this.setState({ information: data })
    //         let body = { collection: data.collection }
    //         let currentData = {}

    //         this.setState({ isLoading: true })


    //         HttpServices.request("getFrame", body, (fetchResult, fetchError, status) => {
    //             // SocketServices.addTopic(this.state.topicId, this.props.data.thing, 'things', null, this.updateData)

    //             // console.log(fetchResult)
    //             this.setState({ isLoading: false })

    //             if (fetchError) { return }

    //             let frame = fetchResult?.info

    //             frame.key = frame._id
    //             frame.section = 'collections'
    //             frame.pageType = 'collection'
    //             frame.fetchUrl = 'getRecords'
    //             frame.addUrl = 'postRecord'
    //             frame.editUrl = 'postRecord'
    //             frame.removeUrl = 'removeRecord'
    //             frame.postBody = { hub: frame?.applet?.hub, applet: frame?.applet?._id }
    //             frame.filter = { hub: frame?.applet?.hub, applet: frame?.applet?._id }
    //             frame.fields.forEach(field => {
    //                 if (!field.key.includes("values.")) {

    //                     field.key = "values." + field.key
    //                 }
    //             });

    //             currentData.frame = frame
    //             this.setState({ frame: frame }, () => {


    //                 let body = frame.filter ? { ...frame.filter } : {}
    //                 // let page = frame

    //                 body.limit = this.state.limit
    //                 body.skip = this.state.skip



    //                 // body.page = page.key
    //                 for (const [key, value] of Object.entries(body)) {
    //                     if (/\{\{(.*?)\}\}/.test(value)) {
    //                         if (this.props.variables) {
    //                             body[key] = this.props.variables[value.replace(/{/g, '').replace(/}/g, '')]
    //                         }
    //                     }
    //                 }
    //                 body.frame = frame?._id
    //                 // body.filter = filter

    //                 // console.log(body)
    //                 // console.log(frame.fetchUrl)
    //                 this.setState({ isLoadingData: true })

    //                 HttpServices.request(frame.fetchUrl, body, (recordsFetchResult, fetchError) => {
    //                     this.setState({ isLoadingData: false })
    //                     if (fetchError) {
    //                         this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.loadDataFailed', description: fetchError.message })
    //                         return
    //                     }
    //                     this.setState({ showTable: false }, () => {

    //                         currentData.data = recordsFetchResult.info

    //                         this.setState({ data: recordsFetchResult.info, showTable: true }, () => {

    //                             this.props.keepCurrentData(this.props.section, currentData)
    //                         })
    //                     })
    //                 })


    //             })

    //         })
    //     } else if (this.props.currentData) {
    //         let currentData = this.props.currentData
    //         this.setState({ data: currentData.data, frame: currentData.frame, showTable: true })
    //     }

    // }


    functionsHandler = (type, name, data, extra, info) => {

        // console.log('functionsHandler', type, name, data, extra, info)
        // if (!this.props.userView) {

        if (this[name]) {
            this[name](data, extra, info)
        } else {
            if (this.props.functionsHandler) {
                this.props.functionsHandler(type, name, data, extra, info)
            }
        }
      
    }



    downloadFile = (fullData, extra, info) => {

        // console.log("params", this.props.params)

        // console.log('downloadFile', fullData, extra, info)
        // let file = 'test.png'



        let data = textVariableReplacer(fullData, info?.source, extra?.headers, 'View Record')

        if (Array.isArray(this.props.params)) {
            for (let i = 0; i < this.props.params.length; i++) {
                const param = this.props.params[i];
                data = this.textVariableReplacer(param?.info, data, param.fields, param.label)

            }
        }


        // console.log(data)
        // return


        saveAs(imageAddress(data))

    }




    openWindow = (prop, extra, info) => {
        // console.log('openWindow', prop, extra, info)
        // console.log('this.props.baseUrl', this.props.baseUrl)
        // console.log(prop, extra, info)

        let newLink = this.props.baseUrl.splice(2)
        // return
        newLink.push(info.page)
        newLink.push(prop._id)
        // return
        // console.log('widgettttap', this.props.applet)
        // console.log('newLink', newLink)

        // return
        this.props.changeWindowLink(newLink)


    }

    openEditModal = (prop, extra) => {
        // console.log('this.props.page', this.props.page)

        if (!this.props.userView) {

            let baseUrl = this.props.baseUrl
            let windowData = this.props.windowData
            let data = { ...this.props.data }


            // console.log("baseUrl, ", baseUrl)
            // console.log("windowData, ", windowData)
            // console.log("data, ", data)
            // console.log(this.props.section)

            
            this.setState({ currentItem: prop, currentIndex: extra?.index },()=>{
                this.RecordViewerModal.showModal()

            })

        }
        return

        let newLink = this.props.baseUrl?.splice(2)
        if (!newLink) {
            newLink = []
        }
        newLink.push(this.props.page?.key)
        newLink.push(prop._id)
        if (this.props.page?.customEdit) {
            let variables = this.props.variables ?? {}
            variables.currentItem = prop
            this.setState({ variables })
            this.props.changeWindowLink(newLink)
        } else {
            this.setState({ currentItem: null }, () => {
                let variables = this.props.variables ?? {}
                variables.currentItem = prop
                this.setState({ variables })
                if (this.state.relevants?.length > 0) {
                    this.setState({ relevantEdit: true })
                }
                else {
                    this.setState({ edit: true })
                }
                this.setState({ currentItem: prop, currentIndex: extra?.index })
                this.props.changeWindowLink(newLink)
            })
        }
    }





    render() {

        let colors = {
            primaryColor: '#5856d6',
            secondaryColor: '#7c7aff',
            textColor: '#fff'
        }

        let iconInvert = chooseFontColor(colors.textColor) == '#fff' ? true : false

        colors.iconInvert = iconInvert
        colors.background = `linear-gradient(90deg, ${colors.primaryColor}, ${colors.secondaryColor})`

        let view = this.props.data?.view ?? {}
        view.type = this.props.data?.type ?? 'table'

        let headersItemModal = null
        let variables = { ...this.props.variables }
        // variables.frameId = this.state.currentRelevantTab ?? this.props.page?._id
        // variables.currentItem = this.state.relevantCurrentItem ?? this.state.currentItem



        return (
            <div className=" w-100 h-100 d-flex flex-column" style={{ maxHeight: 600 }}>
                {/* dashboard-widgets */}
                <div className="flex-1 h-100 w-100" style={{ display: 'inline-block' }}>
                    {/* <div className="d-flex justify-content-between align-items-center p-3" style={{}}> */}
                    {/* <div className="">
                        <p style={{ color: "#080808", fontWeight: '600' }}>Today Tasks</p> */}
                    {/* <p className="pt-1" style={{ color: "#9D9D9D", fontSize: 12 }}>wednsday, 11 may</p> */}

                    {/* <p onClick={() => this.backStage()} style={{ fontSize: '13px' }} className="p-3 flexc">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="mr-2" style={{ width: 15 }}>
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 12h-15m0 0l6.75 6.75M4.5 12l6.75-6.75" />
                                </svg>
                                back
                            </p> */}

                    {/* </div> */}

                    {/* <div className="">
                            <p className='text-bold text-semibig '>My Tasks</p>

                            <div className="flexc mt-1">
                                <div className="mrd-2 flexcc">
                                    <img className="br-20" src={imageAddress('', 'profile')} style={{ height: 20, width: 20, objectFit: 'cover' }} />
                                </div>
                                <div className="flex-1 flexc">
                                    <p className='text-smaller '>Applet Name</p>
                                </div>
                            </div>
                        </div> */}


                    {/* <div className="d-flex "> */}
                    {/* <button className="flexcc px-3 py-2" style={{ background: "#E2EBFA", borderRadius: 50 }}>
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="#0760FB" className='cursor-pointer' style={{ width: 15 }}>
                                <path stroke-linecap="round" stroke-linejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
                            </svg>
                            <p className="ml-1" style={{ color: "#0760FB", fontSize: 13, fontWeight: '400' }}>New Task</p>
                        </button> */}
                    {/* <div className="grayscale-filter">
                                <ButtonAnimated
                                    iconwidth='24px'
                                    onClick={this.addClicked}
                                    title={translate('New Record')}
                                    icon='/assets/icons/plus-white.svg'
                                    textColor={colors?.textColor}
                                    invert={colors?.iconInvert}
                                    bg={colors?.background}
                                />
                            </div> */}
                    {/* </div> */}
                    {/* </div> */}

                    {/* <div className='flexcb mt-1 px-3' style={{}}>

                    <div className="d-flex w-100  pb-1" style={{ borderBottom: '1px solid #eee' }}>
                        {this.state.category.map((item, index) => {
                            return (
                                <button key={index} className='d-flex mrd-1 pb-1 px-2' style={{ borderBottom: '2px solid', borderBottomColor: this.state.currentIndex == index ? '#5856d6' : 'transparent' }} onClick={() => this.setState({ currentItem: item, currentIndex: index })}>
                                    <p style={{ color: this.state.currentIndex == index ? '#5856d6' : '#202020', fontSize: 14, fontWeight: '500' }} className=' text-sm whitespace-nowrap' >{item.name}</p>
                                </button>
                            )
                        })}
                    </div>


                </div> */}

                    {/* <div className='px-3 mt-2'>
                    <div className="flexc">
                        <ActionButton className=''>
                            <div className=" mt-2 mld-3 py-3 px-3 d-flex flex-column w-100" style={{ minWidth: 120, boxShadow: '0px 0px 30px #10101030', backgroundColor: '#fff', borderRadius: 6 }}>
                                <p className="pb-2" style={{ fontSize: 13 }}>test1</p>
                                <p className="pb-2" style={{ fontSize: 13 }}>test2</p>
                                <p className="" style={{ fontSize: 13 }}>test1</p>
                            </div>
                        </ActionButton>
                        <div className="flexcb w-100">
                            <p className='px-2' style={{ fontSize: 14, fontWeight: 500, color: "#101010" }}>{this.state.currentItem?.title1}</p>
                            <div>
                                <FormViewer ref={el => this.form = el} headers={this.state.headers} initData={this.props.initData} formClass="modern" inputClass={'modern-input2'} />
                            </div>
                        </div>                    </div>
                    <p className='pt-2' style={{ fontSize: 12 }}>{this.state.currentItem?.des1}</p>
                </div> */}

                    <div className=" mt-0 br-10 w-100 flex-1 h-100" >
                        
                        {/* {this.props.data?.type} */}
                        {/* {console.log('this.props.pagechecks', this.props.page)} */}
                        <ViewSwitcher
                            applet={this.state.frame?.applet}
                            data={this.state.data}
                            page={this.state.frame}
                            headers={this.state.frame?.fields}
                            params={this.props.params}
                            actions={this.state.actions}
                            width={this.props.width}
                            functionsHandler={this.functionsHandler}
                            submitForm={this.submitForm}
                            changeValue={this.changeValue}
                            view={view}
                            isLoadingData={this.state.isLoadingData}
                            type={this.props.viewType ?? this.props.view?.type}
                        />

                    </div>
                </div>



                <RecordViewerModal
                    ref={el => this.RecordViewerModal = el}
                    page={this.props.page}
                    headers={headersItemModal ?? this.state.frame?.fields}
                    pages={this.props.formPages}
                    onClose={this.itemModalClosed}
                    initData={JSON.parse(JSON.stringify(this.state.currentItem ?? {}))}
                    variables={this.state.variables ?? variables}
                    itemAdded={this.itemAdded}
                    itemEdited={this.itemEdited}
                    width={this.props.width}
                    // showDates={true}
                    submitForm={this.submitForm}
                    background={colors?.background}
                    isMobile={this.props.isMobile}
                    colors={this.props.colors}
                    // data={this.state.data}
                    relevantData={this.state.relevantData}
                    relevants={this.state.relevants}
                    relevantAddClicked={this.relevantAddClicked}
                    windowData={this.props.windowData}
                    changeWindowLink={this.props.changeWindowLink}
                    setData={this.setData}
                    fetchRelevantData={this.fetchRelevantData}
                    fieldOptions={this.fieldOptions}
                    tempValue={this.state.tempValue}
                    updateRecord={this.updateRecord}
                    clearTempValue={this.clearTempValue}
                    applet={this.props.applet}
                    actionsBtn={this.state.relevantActions}
                    functionsHandler={this.functionsHandler}
                    changeValue={this.changeValue}
                    saveUserSettings={this.saveUserSettings}
                    userSettings={this.props.userSettings}
                    stackedKey={this.state.stackedKey ?? this.state.currentView?.settings?.stacked}
                    view={this.state.currentView}
                    setCurrentHead={this.setCurrentHead}
                    currentHead={this.state.currentHead}
                    deleteHeaderField={this.deleteHeaderField}
                    relevantEdit={this.state.relevantEdit}
                    isLoadingData={this.state.isLoadingData}
                />


            </div >
        )
    }
}



export default ViewSwitcherWidget;